// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
import { trpcMutation, trpcQuery } from "@/lib/api/trpc";

export interface LegalDocument {
  version: string;
  body: string;
  summary: string;
  effectiveFrom: string | Date;
}

export interface LegalAcceptanceDocumentStatus {
  acceptedVersion: string | null;
  currentVersion: string;
  needsAcceptance: boolean;
  document: LegalDocument;
}

export interface LegalAcceptanceStatus {
  privacy: LegalAcceptanceDocumentStatus;
  terms: LegalAcceptanceDocumentStatus;
}

export interface LegalVersionSummary {
  id: string;
  version: string;
  effectiveFrom: string | Date;
  effectiveTo: string | Date | null;
  isCurrent: boolean;
  summary?: string;
}

export const LegalService = {
  getPrivacyCurrent: () =>
    trpcQuery<LegalDocument>("legal", "getPrivacyCurrent"),

  getTermsCurrent: () =>
    trpcQuery<LegalDocument>("legal", "getTermsCurrent"),

  getAcceptanceStatus: () =>
    trpcQuery<LegalAcceptanceStatus>("legal", "getAcceptanceStatus"),

  accept: (params: { privacyVersion: string; termsVersion: string }) =>
    trpcMutation<{ success: boolean }>("legal", "accept", params),
};
